export default __webpack_public_path__ + "static/media/facebook_icon.108e36ed.svg";